module.exports = __webpack_public_path__ + "static/media/2_8.038c6f68.png";